module.exports = __webpack_public_path__ + "img/slack-icon.056e7e94.svg";